import React from "react";

export const BillPaymentUnSuccessIcon = () => {
  return (
    <>
      <svg
        width="81"
        height="80"
        viewBox="0 0 81 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="40.5"
          cy="40"
          r="40"
          fill="#CF6679"
          fillOpacity="0.12"
          style={{
            fill: "#CF6679",
            fill: "color(display-p3 0.8118 0.4000 0.4745)",
            fillOpacity: "0.12",
          }}
        />
        <circle
          cx="40.5"
          cy="40"
          r="19.5"
          fill="#CF6679"
          stroke="#CF6679"
          style={{
            fill: "#CF6679",
            fill: "color(display-p3 0.8118 0.4000 0.4745)",
            fillOpacity: 1,
            stroke: "#CF6679",
            stroke: "color(display-p3 0.8118 0.4000 0.4745)",
            strokeOpacity: 1,
          }}
        />
        <path
          d="M33.6602 46.8389L48.3389 32.1602L33.6602 46.8389Z"
          fill="#CF6679"
          style={{
            fill: "#CF6679",
            fill: "color(display-p3 0.8118 0.4000 0.4745)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M33.6602 46.8389L48.3389 32.1602"
          stroke="white"
          style={{ stroke: "white", strokeOpacity: 1 }}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M33.8249 31.9955L48.1751 46.9955L33.8249 31.9955Z"
          fill="#CF6679"
          style={{
            fill: "#CF6679",
            fill: "color(display-p3 0.8118 0.4000 0.4745)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M33.8249 31.9955L48.1751 46.9955"
          stroke="white"
          style={{ stroke: "white", strokeOpacity: 1 }}
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};
